<div class="page-wrapper">
    <mat-card class="centered-card">
        <mat-toolbar class="justify-content-center" color="primary">Payment</mat-toolbar>
        <form class="p-3">
            <div class="mat-typography">
                <H3>Payee: {{paymentData.payee}}</H3>
            </div>
            <div class="mat-typography">
                <H3>Amount: US${{paymentData.amount}}</H3>
            </div>
            <div class="mat-typography">
                <H4>Please enter credit card number, expiration(MM/YY), CVC/CVV and Postal/Zip code below</H4>
            </div>
            <div id="form-field" style="margin-top: 20px;margin-bottom: 20px;">
                <div id="card-info" #cardInfo></div>
            </div>
            <div class="d-flex justify-content-center">
                <button class="m-2" mat-raised-button type="submit" (click)="confirmPayment()" color="primary">Pay
                    Now</button>
                <button class="m-2" mat-raised-button type="button" color="primary" (click)="cancel()">Cancel</button>
            </div>

        </form>
    </mat-card>
</div>